"use strict"
exports.__esModule = true;
exports.RemoveFormatIconConfig = {
  name: 'RemoveFormatIcon',
  height: 512,
  width: 640,
  svgPath: 'M336 416h-11.17l9.26-27.77L267 336.4 240.49 416H208a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm297.82 42.1L377 259.59 426.17 112H544v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16H176a16 16 0 0 0-16 16v43.9L45.46 3.38A16 16 0 0 0 23 6.19L3.37 31.46a16 16 0 0 0 2.81 22.45l588.36 454.72a16 16 0 0 0 22.46-2.81l19.64-25.27a16 16 0 0 0-2.82-22.45zM309.91 207.76L224 141.36V112h117.83z',
  yOffset: 0,
  xOffset: 0,
};
exports.RemoveFormatIcon = require('../createIcon').createIcon(exports.RemoveFormatIconConfig);
exports["default"] = exports.RemoveFormatIcon;